import "./Pages.css";
import { useNavigate } from 'react-router-dom';
import ErrorScreen from '../components/ErrorScreen/ErrorScreen';
import { selectParameter } from '../reduxSlices/parametersSlice';
import { useSelector } from 'react-redux';
import { getRedirectUri } from "../utils/authHelpers";
import Translatable from "../components/Translatable/Translatable";

const ErrorPage = () => {
  const { serverError } = useSelector(selectParameter);
  const navigate = useNavigate();
  const campusToken = localStorage.getItem("campusToken");
  if (!serverError) {
    navigate("/login");
    return null;
  }

  const handleGoBack = () => {
    if (campusToken) {
      window.location.href = getRedirectUri();
    } else {
      navigate("/login");
    }
  };

  return (
    <div style={{ textAlign: 'center', marginTop: '50px' }}>
     <ErrorScreen />
      <button onClick={handleGoBack} className="back-to-login-btn">
        <Translatable as="span" capitalize>Volver al inicio</Translatable>
      </button>
    </div>
  );
};

export default ErrorPage;